export function getSchoolInternshipweek(id) {
    return this.get(`/api/v2/school/internshipweeks/${id}`)
}

export function putSchoolInternshipweek(id, data) {
    return this.put(`/api/v2/school/internshipweeks/${id}`, data)
}
